module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qnerv5-5fdc4bd64a544d046615a50013affb25.jpg";